// extracted by mini-css-extract-plugin
export default {"subText":"privacyPolicy_subText__gFRH2","mainCont":"privacyPolicy_mainCont__eoNW6","contentStyling":"privacyPolicy_contentStyling__YVuaz"};